<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#a63232">
      <inline-svg :src="require('@/assets/svg/thumb_down.svg')" width="25" />
      Reject Role
    </SecondaryButton>
    <RejectBookingDialog
      :isOpen="isOpen"
      @close="closeDialog"
      @reject="handleReject"
    />
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import RejectBookingDialog from "@/views/bookings/components/ConfirmDialogs/RejectBookingDialog";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "RejectBookingAction",
  components: {
    BaseAction,
    RejectBookingDialog,
    SecondaryButton,
    InlineSvg
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    },
    handleReject() {
      this.$emit("reject");
    }
  }
};
</script>
